module.exports = __webpack_public_path__ + "img/placeholder.bc10fc79.jpg";